<mat-form-field appearance="outline" (click)="onSummaryClick()">
  @if (filterName) {
    <mat-label>
      {{ filterName | translate }}
    </mat-label>
  }
  <nimbus-filter-summary-input-mask [formControl]="formControl" [summary]="summary"></nimbus-filter-summary-input-mask>
  <i matSuffix class="cursor-pointer" [nimbusIcon]="ICONS.CLOSE_LIGHT" (click)="onRemoveFilter($event)"></i>
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i class="error-triangle" [nimbusIcon]="ICONS.EXCLAMATION_TRIANGLE"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
  @if (warningMessage) {
    <mat-hint align="start"> <i [nimbusIcon]="ICONS.INFO_CIRCLE" class="error-triangle"></i>{{ warningMessage }} </mat-hint>
  }
</mat-form-field>
